import {
  type RouteObject,
} from "react-router";
import { UserForExternalAdminInviteApp, UserForInternalAdminInviteApp } from "systemsettings/UserInvite/UserInviteApp";
import UserForExternalAdminListApp from "UserForExternalAdmin/List/App";
import UserForInternalAdminListApp from "UserForInternalAdmin/List/App";

declare let viewModel: any;

export const userRoute: RouteObject = {
  path: "user",
  children: [{
    path: "internal",
    loader: () => viewModel,
    Component: UserForInternalAdminListApp,
  }, {
    path: "internal/invite",
    loader: () => viewModel,
    Component: UserForInternalAdminInviteApp,
  }, {
    path: "external",
    loader: () => viewModel,
    Component: UserForExternalAdminListApp,
  }, {
    path: "external/invite",
    loader: () => viewModel,
    Component: UserForExternalAdminInviteApp,
  }]
};